import { createContext, ReactNode } from "react";

export type BreadcrumbInfo = {
  title?: ReactNode | null,
  disabled?: boolean,
  to?: string
  href?: string
}

export const BreadcrumbsContext = createContext<BreadcrumbInfo[]>([]);
